import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { admin } from './admin-api';
import ConnectAi from './ConnectAi';

export default function Integrations() {
  const qc = useQueryClient();
  const integ = useQuery({ queryKey: ['admin', 'integrations'], queryFn: admin.integrations });

  const sapSync = useMutation({
    mutationFn: admin.sapSync,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'integrations'] }),
  });

  if (integ.isLoading) return <div className="small faint">Loading integrations…</div>;
  if (integ.isError) return <div className="login-err">Could not load integrations.</div>;
  const i = integ.data!;

  return (
    <div>
      <div className="ph">Admin · Integrations</div>
      <div className="h2">External systems</div>
      <p className="lead">Connect a language model below; wire status, test buttons, and activity for the rest.</p>

      {/* SAP */}
      <div className="panel">
        <div className="qhead">
          <span className="qdot" style={{ background: i.sap.connection_status === 'connected' ? 'var(--olive)' : 'var(--faint)' }} />
          SAP S/4HANA
        </div>
        <div className="small" style={{ marginBottom: 12 }}>
          <span className="tag gold">MOCK DATA</span>&nbsp;
          <span className="faint">Wire to real SAP in V3 (operator decision pending).</span>
        </div>
        <Row k="Status" v={i.sap.connection_status} accent="olive" />
        <Row k="Endpoint" v={i.sap.endpoint} mono />
        <Row k="Last sync" v={new Date(i.sap.last_sync_at).toLocaleString()} />
        <Row k="Last sync duration" v={`${i.sap.last_sync_duration_ms} ms`} />
        <Row k="SKU count" v={`${i.sap.sku_count}`} mono />
        <Row k="Customer count" v={`${i.sap.customer_count}`} mono />
        <Row k="Open orders" v={`${i.sap.open_orders}`} mono />
        <button
          type="button"
          className="btn primary"
          style={{ marginTop: 12 }}
          onClick={() => sapSync.mutate()}
          disabled={sapSync.isPending}
        >
          {sapSync.isPending ? 'Syncing…' : '↻ Sync now'}
        </button>
      </div>

      <ConnectAi />
    </div>
  );
}

function Row({ k, v, mono, accent }: { k: string; v: string; mono?: boolean; accent?: 'olive' | 'amber' | 'red' | 'teal' }) {
  return (
    <div className="row" style={{ justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #241f18' }}>
      <span style={{ fontSize: 14 }}>{k}</span>
      {accent ? (
        <span className={`tag ${accent}`} style={{ fontSize: 12 }}>{v}</span>
      ) : (
        <span className={mono ? 'mono small' : 'small'}>{v}</span>
      )}
    </div>
  );
}
